var _slicedToArray = require("D:\\GithubDesktop\\Echo\\echograde\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var $ = require('cheerio');

var isClassHeader = function isClassHeader(_ref) {
  var c = _ref.c;
  return c !== undefined && c.length > 0 && c[0].cId !== undefined;
};

var isScoreElement = function isScoreElement(_ref2) {
  var h = _ref2.h;
  return h !== undefined && $(h).find('a').length;
};

var getData = function getData(_ref3) {
  var h = _ref3.h;
  var element = $(h).find('a')[0];
  return {
    course: Number($(element).attr('data-cni')),
    bucket: $(element).attr('data-bkt'),
    score: Number($(element).text())
  };
};

var merge = function merge(parent, child) {
  return {
    course: parent.course || child.course,
    scores: parent.scores.concat({
      bucket: child.bucket,
      score: child.score
    })
  };
};

module.exports = function (data) {
  var values = Object.entries(data);
  var targetPair = values.find(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
        key = _ref5[0];

    return /stuGradesGrid_\d{5}_\d{3}/.test(key);
  });
  if (targetPair === undefined) throw new Error('stuGradesGrid not found');
  var targetData = targetPair[1];
  if (targetData.tb === undefined) throw new Error('stuGradesGrid.tb not found');
  var r = targetData.tb.r;
  if (r === undefined) return [];
  return targetData.tb.r.filter(isClassHeader).map(function (_ref6) {
    var c = _ref6.c;
    return c.filter(isScoreElement).map(getData).reduce(merge, {
      scores: []
    });
  });
};